/**
 * Dismissal rules shared by the modal overlays (Dialog, Sheet). Radix calls
 * these handlers before it closes the overlay; calling `preventDefault()`
 * keeps it open.
 */
/**
 * An element that owns an open popup of its own (a combobox or a menu button
 * with `aria-expanded="true"`). Escape pressed there belongs to that popup:
 * closing the whole overlay as well would throw away the user's work.
 *
 * Radix popups (Monarch Select, Combobox, Popover, DropdownMenu) are already
 * stacked layers and never reach this check; it covers hand-built ones.
 */
const OPEN_POPUP_OWNER = '[role="combobox"][aria-expanded="true"], [aria-haspopup][aria-expanded="true"]:not([aria-haspopup="false"])';
export function ownsOpenPopup(target) {
    return (typeof Element !== 'undefined' &&
        target instanceof Element &&
        target.closest(OPEN_POPUP_OWNER) !== null);
}
/** Wraps a consumer's Radix handlers with the dismissal rules. */
export function dismissHandlers(rules, handlers) {
    return {
        onEscapeKeyDown(event) {
            handlers.onEscapeKeyDown?.(event);
            if (rules.busy || (rules.escapeGuard && ownsOpenPopup(event.target))) {
                event.preventDefault();
            }
        },
        onInteractOutside(event) {
            handlers.onInteractOutside?.(event);
            if (rules.busy || !rules.closeOnOutsideClick)
                event.preventDefault();
        },
    };
}
//# sourceMappingURL=dismiss.js.map